import { combineReducers } from 'redux'
import { all } from 'redux-saga/effects'

// Reducers
import authReducer from './auth/reducers'
import appReducer from './app/reducers'
import userReducer from './user/reducers'
import passwordRecoveryReducer from './passwordRecovery/reducers'

// Sagas
import authSagas from './auth/sagas'
import userSagas from './user/sagas'
import passwordRecoverySagas from './passwordRecovery/sagas'

export function * rootSaga () {
  yield all([
    authSagas(),
    userSagas(),
    passwordRecoverySagas()
  ])
}

export default combineReducers({
  app: appReducer,
  auth: authReducer,
  user: userReducer,
  passwordRecovery: passwordRecoveryReducer
})
